import axios from 'axios';
import { store } from '../redux/Store';
import { BaseURL } from './Endpoints';
import { resetUser } from '../redux/reducers/UserSlice';
import { toastMessage } from 'shared/components/toast/Toast';

export const HTTP_CLIENT = axios.create({
    baseURL: BaseURL,
    timeout: 60000 // 60 seconds timeout
});

// Debounce flag - ek baar logout hone ke baad dobara trigger na ho
let isLoggingOut = false;
let lastTimeoutToast = 0;

const setupAxios = () => {
    HTTP_CLIENT.interceptors.request.use(
        (config) => {
            const token = store.getState().root?.user?.token;
            if (token) {
                config.headers['authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (err) => Promise.reject(err)
    );

    HTTP_CLIENT.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            const status = error?.response?.status;
            const errorMessage = error?.response?.data?.message || '';

            // Handle network timeout or connection reset gracefully - DO NOT LOGOUT
            const isTimeoutOrNetworkError =
                error.code === 'ECONNABORTED' ||
                error.message?.toLowerCase().includes('timeout') ||
                error.message?.toLowerCase().includes('network error') ||
                status === 504 ||
                status === 502 ||
                status === 503;

            if (isTimeoutOrNetworkError) {
                const now = Date.now();
                if (now - lastTimeoutToast > 4000) {
                    lastTimeoutToast = now;
                    toastMessage('error', 'Server is taking longer to respond or is busy. Please wait a moment and try again.');
                }
                return Promise.reject(error);
            }

            // Server 500 internal errors - DO NOT LOGOUT
            if (status === 500) {
                toastMessage('error', errorMessage || 'A server error occurred. Please try again.');
                return Promise.reject(error);
            }

            // Sirf genuine JWT token expire/invalid hone par logout karein
            const isTokenError =
                status === 401 &&
                (errorMessage?.toLowerCase().includes('token') ||
                 errorMessage?.toLowerCase().includes('jwt') ||
                 errorMessage?.toLowerCase().includes('expired') ||
                 errorMessage?.toLowerCase().includes('unauthorized') ||
                 errorMessage?.toLowerCase().includes('session'));

            if (isTokenError && !isLoggingOut) {
                isLoggingOut = true;
                store.dispatch(resetUser());
                toastMessage('error', 'Session expired. Please login again.');
                // 5 second baad flag reset karein
                setTimeout(() => { isLoggingOut = false; }, 5000);
            }

            return Promise.reject(error);
        }
    );
};

export const initialConfig = () => {
    setupAxios();
};

initialConfig();

